import { getProspectGroups } from '@scoir/my-colleges/lane-grouping'
import { concat, filter, forEach, get, identity, indexOf, keyBy, size, sortBy } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  loaded: false,
  prospects: [],
  prospectsByScid: {},
  groups: getProspectGroups([]),
  topChoices: [],
  unrankedChoices: [],
}

const PROSPECT_ID_KEY = 'Id'
const PROSPECT_SCID_KEY = 'CollegeScid'
const PROSPECT_NAME_KEY = 'CollegeName'
export const getScidFromProspect = (prospect) => prospect[PROSPECT_SCID_KEY]
export const getProspectsByScid = (prospects) => keyBy(prospects, PROSPECT_SCID_KEY)
export const getProspectsById = (prospects) => keyBy(prospects, PROSPECT_ID_KEY)
export const sortProspectsAlpha = (prospects) => sortBy(prospects, [PROSPECT_NAME_KEY])
export const getCollegeName = (prospect) => get(prospect, PROSPECT_NAME_KEY)

export const getUnrankedChoices = (topChoices, prospects) => {
  const topChoicesObj = keyBy(topChoices, identity)
  const unrankedChoices = []
  forEach(prospects, (prospect) => {
    const scid = getScidFromProspect(prospect)
    if (!topChoicesObj[scid]) {
      unrankedChoices.push(scid)
    }
  })
  return unrankedChoices
}

export const getInterestedProspects = (groups) => {
  return concat(get(groups, 'applying', []), get(groups, 'applied', []), get(groups, 'following', []))
}

export const getProspectsWithApplications = (groups) => {
  return concat(get(groups, 'applying', []), get(groups, 'applied', []))
}

const getUpdatedState = (state, action) => {
  const topChoices = action.topChoices
  const prospects = action.payload
  const prospectsByScid = getProspectsByScid(prospects)
  const prospectsById = getProspectsById(prospects)
  const groups = getProspectGroups(prospects)
  const interestedProspects = getInterestedProspects(groups)
  const interestedProspectsAlpha = sortProspectsAlpha(interestedProspects)
  const prospectsWithApplications = getProspectsWithApplications(groups)
  const unrankedChoices = getUnrankedChoices(topChoices, interestedProspectsAlpha)
  return {
    loaded: true,
    prospects,
    prospectsByScid,
    prospectsById,
    groups,
    topChoices,
    prospectsWithApplications,
    unrankedChoices,
  }
}

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.FETCH_MY_PROSPECTS_SUCCESS:
      return getUpdatedState(state, action)
    default:
      return state
  }
}

export default reducer

export const selectGroups = (store) => {
  return get(store, 'prospects.groups', {})
}

export const selectProspects = (store) => {
  return get(store, 'prospects.prospects', [])
}

export const countInterestedProspects = (store) => {
  const groups = selectGroups(store)
  const interestedProspects = getInterestedProspects(groups)
  return size(interestedProspects)
}

export const selectFollowingProspectByScid = (store, scid) => {
  const following = selectGroups(store).following
  return filter(following, { CollegeScid: scid })
}

export const selectTopChoices = (store) => {
  return get(store, 'prospects.topChoices', [])
}

export const selectTopChoicePosition = (store, scid) => {
  const topChoices = selectTopChoices(store)
  return indexOf(topChoices, scid)
}

export const selectUnrankedChoices = (store) => {
  return get(store, 'prospects.unrankedChoices', [])
}

export const selectProspectsByScid = (store) => {
  return get(store, 'prospects.prospectsByScid', {})
}

export const selectProspectsById = (store) => {
  return get(store, 'prospects.prospectsById', {})
}

export const selectProspectByScid = (store, scid) => {
  return get(selectProspectsByScid(store), scid)
}

export const selectProspectById = (store, id) => {
  return get(selectProspectsById(store), id)
}

export const selectProspectName = (store, scid) => {
  return getCollegeName(selectProspectByScid(store, scid))
}

export const getCollegeNameByScid = (prospectsByScid, scid) => {
  return getCollegeName(get(prospectsByScid, scid))
}

export const selectProspectWithApplicationByScid = (store, scid) => {
  const withApplications = get(store, 'prospects.prospectsWithApplications', [])
  return filter(withApplications, { CollegeScid: scid })
}
